import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanEditUser(loggedInUser, user) {
    if (loggedInUser.role === Role.ADMIN) {
        return true;
    }

    if (loggedInUser.role === Role.MANAGER) {
        return user !== null ? user.role !== Role.ADMIN : false;
    }

    return false
}
export default CanEditUser;